// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7352620adb94dd68f4ae","655":"a42203d43f7f2387d25c"}[chunkId] + ".js";
};